import { render, staticRenderFns } from "./ReservationAccommodationHeader.vue?vue&type=template&id=1957bcfc&scoped=true&"
import script from "./ReservationAccommodationHeader.vue?vue&type=script&lang=js&"
export * from "./ReservationAccommodationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReservationAccommodationHeader.vue?vue&type=style&index=0&id=1957bcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1957bcfc",
  null
  
)

export default component.exports